import { render, staticRenderFns } from "./floor-bgImg.vue?vue&type=template&id=268ed5c4"
import script from "./floor-bgImg.vue?vue&type=script&lang=js"
export * from "./floor-bgImg.vue?vue&type=script&lang=js"
import style0 from "./floor-bgImg.vue?vue&type=style&index=0&id=268ed5c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports